export default function InstallationGuide() {
  const steps = [
    {
      number: '01',
      title: 'Site Preparation',
      description: 'Level ground preparation and foundation setup. Minimal excavation required.',
      duration: '1-2 days',
      icon: 'ri-hammer-line'
    },
    {
      number: '02',
      title: 'Delivery & Positioning',
      description: 'Capsule delivered fully assembled. Crane placement onto prepared foundation.',
      duration: '1 day',
      icon: 'ri-truck-line'
    },
    {
      number: '03',
      title: 'Utility Connections',
      description: 'Connect electrical, water, and sewage systems. Solar panel installation if applicable.',
      duration: '2-3 days',
      icon: 'ri-plug-line'
    },
    {
      number: '04',
      title: 'Testing & Handover',
      description: 'System testing, quality inspection, and staff training. Ready for guests.',
      duration: '1 day',
      icon: 'ri-checkbox-circle-line'
    }
  ];

  return (
    <section className="relative py-24 lg:py-32 bg-gradient-to-b from-transparent via-cyan-500/5 to-transparent w-full">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full">
        {/* Section Header */}
        <div className="text-center mb-16 lg:mb-20">
          <h2 className="text-4xl sm:text-5xl lg:text-6xl font-thin mb-6">
            Installation <span className="text-cyan-400">Process</span>
          </h2>
          <p className="text-lg sm:text-xl text-gray-400 max-w-3xl mx-auto">
            Quick and efficient setup process from delivery to operation
          </p>
        </div>

        {/* Timeline */}
        <div className="relative">
          {/* Connection Line */}
          <div className="hidden lg:block absolute left-1/2 top-0 bottom-0 w-0.5 bg-gradient-to-b from-cyan-500/50 via-cyan-500/30 to-cyan-500/50 transform -translate-x-1/2"></div>

          {/* Steps */}
          <div className="space-y-12 lg:space-y-20">
            {steps.map((step, index) => (
              <div 
                key={index}
                className={`flex flex-col lg:flex-row gap-8 items-center ${
                  index % 2 === 0 ? 'lg:flex-row' : 'lg:flex-row-reverse'
                }`}
              >
                {/* Content */}
                <div className="w-full lg:w-5/12">
                  <div className={`bg-gradient-to-br from-gray-900/80 to-gray-800/50 border border-cyan-500/30 rounded-3xl p-8 ${
                    index % 2 === 0 ? 'lg:text-right' : 'lg:text-left'
                  }`}>
                    <div className={`flex items-center gap-4 mb-4 ${
                      index % 2 === 0 ? 'lg:flex-row-reverse lg:justify-end' : 'lg:justify-start'
                    }`}>
                      <div className="w-14 h-14 bg-cyan-500/10 rounded-2xl flex items-center justify-center flex-shrink-0">
                        <i className={`${step.icon} text-3xl text-cyan-400`}></i>
                      </div>
                      <span className="text-5xl font-thin text-cyan-400/30">{step.number}</span>
                    </div>
                    <h3 className="text-2xl font-medium mb-3 text-white">{step.title}</h3>
                    <p className="text-gray-400 mb-4 leading-relaxed">{step.description}</p>
                    <div className="inline-flex items-center gap-2 px-4 py-2 bg-cyan-500/10 rounded-full">
                      <i className="ri-time-line text-cyan-400"></i>
                      <span className="text-sm text-cyan-400">{step.duration}</span>
                    </div>
                  </div>
                </div>

                {/* Center Point */}
                <div className="hidden lg:flex w-2/12 justify-center">
                  <div className="w-4 h-4 bg-cyan-400 rounded-full shadow-[0_0_20px_rgba(0,217,255,0.6)]"></div>
                </div>

                {/* Spacer */}
                <div className="hidden lg:block w-5/12"></div>
              </div>
            ))}
          </div>
        </div>

        {/* Total Timeline */}
        <div className="mt-16 bg-gradient-to-br from-cyan-500/10 to-transparent border border-cyan-500/30 rounded-3xl p-8 text-center">
          <h3 className="text-2xl font-medium mb-4">Total Installation Time</h3>
          <div className="text-5xl font-thin text-cyan-400 mb-2">5-7 Days</div>
          <p className="text-gray-400">From site preparation to guest-ready operation</p>
        </div>

        {/* Support Info */}
        <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-6">
          <div className="bg-gradient-to-br from-gray-900/50 to-gray-800/30 border border-cyan-500/20 rounded-2xl p-6 text-center">
            <i className="ri-customer-service-line text-4xl text-cyan-400 mb-3"></i>
            <h4 className="text-lg font-medium mb-2">Installation Support</h4>
            <p className="text-sm text-gray-400">Expert team guides entire process</p>
          </div>
          <div className="bg-gradient-to-br from-gray-900/50 to-gray-800/30 border border-cyan-500/20 rounded-2xl p-6 text-center">
            <i className="ri-tools-line text-4xl text-cyan-400 mb-3"></i>
            <h4 className="text-lg font-medium mb-2">Maintenance Training</h4>
            <p className="text-sm text-gray-400">Comprehensive staff training included</p>
          </div>
          <div className="bg-gradient-to-br from-gray-900/50 to-gray-800/30 border border-cyan-500/20 rounded-2xl p-6 text-center">
            <i className="ri-shield-check-line text-4xl text-cyan-400 mb-3"></i>
            <h4 className="text-lg font-medium mb-2">Warranty Coverage</h4>
            <p className="text-sm text-gray-400">2-year comprehensive warranty</p>
          </div>
        </div>
      </div>
    </section>
  );
}